import { render, staticRenderFns } from "./TipWithdraw.vue?vue&type=template&id=cf2835d6&scoped=true&"
import script from "./TipWithdraw.vue?vue&type=script&lang=js&"
export * from "./TipWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./TipWithdraw.vue?vue&type=style&index=0&id=cf2835d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2835d6",
  null
  
)

export default component.exports